import React, { useEffect, useMemo, useState } from "react";
import Sidebar from "../../../components/admin/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import useDash from "../../../assets/css/dash.module.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import useISPowner from "../../../hooks/useISPOwner";
import { FontColor, FourGround } from "../../../assets/js/theme";
import Loader from "../../../components/common/Loader";
import {
  ArchiveFill,
  ArrowClockwise,
  PenFill,
  Plus,
  ThreeDots,
} from "react-bootstrap-icons";
import Table from "../../../components/table/Table";
import Footer from "../../../components/admin/footer/Footer";
import BandwidthDialog from "./BandwidthDialog";
import {
  deleteBandwidthPackage,
  getBandwidthPackageByISPOwner,
} from "../../../features/apiCallReseller";

const Bandwidth = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // get user & current user data form useISPOwner hooks
  const { ispOwnerId } = useISPowner();

  //---> Get ispOwner bandwidth packages form redux store
  const packages = useSelector((state) => state?.reseller?.bandwidthPackage);

  //---> Local State
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [bandwidth, setBandwidth] = useState({});

  // get api call
  useEffect(() => {
    !packages?.length &&
      getBandwidthPackageByISPOwner(dispatch, ispOwnerId, setIsLoading);
  }, []);

  const reloadHandler = () => {
    getBandwidthPackageByISPOwner(dispatch, ispOwnerId, setIsLoading);
  };

  const handleDeleteBandwidthPackage = (id) => {
    let confirm = window.confirm(t("deleteBandwidthPackage"));

    if (confirm) {
      deleteBandwidthPackage(dispatch, id, setLoading);
    }
  };

  // table column
  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: "#",
        id: "row",
        accessor: (row) => Number(row.id + 1),
        Cell: ({ row }) => <strong>{Number(row.id) + 1}</strong>,
      },
      {
        width: "12%",
        Header: t("name"),
        accessor: "name",
      },
      {
        width: "10%",
        Header: t("rate"),
        accessor: "rate",
      },
      {
        width: "7%",
        Header: () => <div className="text-center">{t("action")}</div>,
        id: "option",
        Cell: ({ row: { original } }) => (
          <div className="d-flex justify-content-center align-items-center">
            <div className="dropdown">
              <ThreeDots
                className="dropdown-toggle ActionDots"
                id="areaDropdown"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu" aria-labelledby="resellerDropdown">
                <li
                  onClick={() => {
                    setBandwidth(original);
                    setModalStatus("package");
                    setShow(true);
                    setIsUpdate(true);
                  }}
                >
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <PenFill />
                      <p className="actionP">{t("edit")}</p>
                    </div>
                  </div>
                </li>

                <li onClick={() => handleDeleteBandwidthPackage(original?._id)}>
                  <div className="dropdown-item">
                    <div className="customerAction">
                      <ArchiveFill />
                      <p className="actionP">{t("delete")}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ),
      },
    ],
    [t]
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />

      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <FourGround>
                <div className="collectorTitle d-flex justify-content-between px-4">
                  <div>{t("bandwidth")}</div>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="reloadBtn">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <ArrowClockwise
                          className="arrowClock"
                          title={t("refresh")}
                          onClick={() => reloadHandler()}
                        />
                      )}
                    </div>

                    <div
                      title={t("bandwidth")}
                      onClick={() => {
                        setModalStatus("package");
                        setShow(true);
                      }}
                    >
                      <Plus className="addcutmButton" />
                    </div>
                  </div>
                </div>
              </FourGround>

              <FourGround>
                <div className="collectorWrapper mt-2 py-1">
                  <div className="table-section">
                    <Table
                      isLoading={isLoading}
                      columns={columns}
                      data={packages}
                    />
                  </div>
                </div>
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {/* Package dialog */}
      {modalStatus === "package" && (
        <BandwidthDialog {...{ show, setShow, isUpdate, bandwidth }} />
      )}
    </>
  );
};

export default Bandwidth;
